import { render, staticRenderFns } from "./OverlayModal.vue?vue&type=template&id=2a29772b&scoped=true&"
import script from "./OverlayModal.vue?vue&type=script&lang=ts&"
export * from "./OverlayModal.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayModal.vue?vue&type=style&index=0&id=2a29772b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29772b",
  null
  
)

export default component.exports